export const pendingBookings = {
  configTitle: "Set up direct bookings",
  configText:
    "Enable direct bookings to manage pending payments and booking requests from your guests right here.",
  reminderLabel: "Reminder:",
  reminderReasonIntent: "payment pending from",
  reminderReasonUnassigned: "assign room to",
  reminderReasonRequest: "request to review from",
  combined: "Combined · {count} rooms",
  expired: "Expired",
  toastSuccessTitle: "Success",
  toastErrorTitle: "Error",
  toastWarningTitle: "Warning",
};
